
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { QuoteDto } from 'fourwaves-shared';

@Component({})
export default class Breadcrumb extends Vue {
  @Prop({ required: true }) currentPage!: string;
  @Prop({ required: false, default: null }) quote!: QuoteDto | null;
}
